// extracted by mini-css-extract-plugin
export default {"wrapper":"CommunicationsPage_wrapper__Mk6u9","tabs":"CommunicationsPage_tabs__F+7-X"};